import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Router from "./router";
import AppProvider from "./context/App.context";
import { logAnalyticEvent } from "./analytics.js";
import { EVENT_NAME } from "./constants";
import setAppHeight from "./hooks/useAppHeight";
import ApiErrorProvider from "./context/ApiErrorProvider";
import ShortLinkHandlerProvider from "./context/ShortLinkHandlerProvider";
import { useSessionManager } from "./hooks/useSessionManager.js";
import AnalyticsProvider from "./context/AnalyticsProvider.jsx";

function App() {
  setAppHeight();
  useSessionManager();

  useEffect(() => {
    const startTime = Date.now();
    logAnalyticEvent(EVENT_NAME.APP_OPEN, {});
    return () => {
      const endTime = Date.now();
      const timeSpent = endTime - startTime;
      logAnalyticEvent(EVENT_NAME.SESSION_DURATION, { time_spent: timeSpent });
    };
  }, []);

  return (
    <BrowserRouter>
      <ShortLinkHandlerProvider>
        <ApiErrorProvider>
          <AppProvider>
            <AnalyticsProvider>
              <Router />
              <ToastContainer />
            </AnalyticsProvider>
          </AppProvider>
        </ApiErrorProvider>
      </ShortLinkHandlerProvider>
    </BrowserRouter>
  );
}

export default App;
